import React, { useEffect } from 'react';
import FilterDropdown from '../../FilterDropdown/FilterDropdown';
import FilterButton from '../../FilterButton/FilterButton';
import useFilterState from '../../../hooks/useFilterState';
import useFilterItemsWithAmount from '../../../hooks/useFilterItemsWithAmount';
import { filtersData } from '../../../constants/filtersData';
import { filterNames } from '../../../constants/filterNames';
import FilterContainer from '../../FilterContainer/FilterContainer';
import SelectedOption from '../../SelectedOption/SelectedOption';
import useRequestCreationMethod from '../../../../../queries/useRequestCreationMethods';
import { CreationMethodIcon } from '../../../../../components/requestComponents/RequestCreationMethod/RequestCreationMethod';
import { useFilterOptionsShorter } from '../../../hooks/useFilterOptionsShorter';
import { HiddenSelectedOptions } from '../../HiddenSelectedOptions/HiddenSelectedOptions';

const filter = filtersData[filterNames.creationMethods];

const CreationMethodsFilter = ({ disabled = false }) => {
  const [filterState, setFilterState] = useFilterState(filter);

  const { data } = useRequestCreationMethod({ staleTime: Infinity });

  const { items, itemsMap } = useFilterItemsWithAmount({
    data,
    requestKey: 'creationMethod.id',
  });

  const handleItemRemove = (id) => {
    const newState = filterState.filter((itemId) => itemId !== id);

    setFilterState(newState);
  };

  const hasFilter = filterState.length > 0;
  const allSelected = hasFilter && itemsMap.size === filterState.length;

  useEffect(() => {
    if (filterState.length && items.length) {
      const newFilter = filterState.filter((filterId) =>
        items.some((item) => item.id === filterId)
      );

      setFilterState(newFilter);
    }
  }, [items, filterState]);

  const filteredItems = items.filter((item) => filterState.includes(item.id));
  const { visibleItems, hiddenItems } = useFilterOptionsShorter(filteredItems);

  return (
    <FilterContainer>
      <FilterDropdown
        disabled={disabled}
        filter={filter}
        items={items}
        getItemContent={(item) => (
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <CreationMethodIcon methodId={item.id} />
            <span style={{ marginLeft: '6px' }}>{item.name}</span>
          </span>
        )}
        getSearchContent={(item) => item.name}
        renderButton={({ visible }) => (
          <FilterButton
            text="Способ создания"
            opened={visible}
            selected={hasFilter}
          />
        )}
      />
      {allSelected ? (
        <SelectedOption
          text="Все"
          onRemove={() => setFilterState([])}
        />
      ) : (
        <>
          {visibleItems.map((item) => (
            <SelectedOption
              key={item.id}
              text={item.name}
              value={item.id}
              onRemove={handleItemRemove}
            />
          ))}
          {Array.isArray(hiddenItems) && !!hiddenItems.length && (
            <HiddenSelectedOptions
              hiddenItems={hiddenItems}
              handleItemRemove={handleItemRemove}
            />
          )}
        </>
      )}
    </FilterContainer>
  );
};

export default CreationMethodsFilter;
